/**
 * PersistEmailDestinatarioRequest
 * @author ftgibran
 */
import {$, HttpIgnore, Model, ResponseFill} from 'simpli-web-sdk'
import EmailDestinatario from '@/model/resource/EmailDestinatario'

@HttpIgnore()
export default class PersistEmailDestinatarioRequest extends Model {
  readonly $name: string = 'PersistEmailDestinatarioRequest'

  @ResponseFill()
  emails: EmailDestinatario[] = []

  async persistEmailDestinatario(spinner = 'persistEmailDestinatario') {
    const fetch = async () => {
      return await this.POST('/user/email-destinatario', this)
    }

    return await $.await.run(fetch, spinner)
  }
}
